import { initialsAvatar } from "./initialsAvatar";
import { scrubHtml } from "@/lib/utils";

// to ensure consistent FE/BE-rendering of user avatars
export function userAvatar(user, options = {}) {
  if (!user) return "";

  const rounded = options.square
    ? "rounded-none"
    : options.roundedLeft
      ? "rounded-l"
      : "rounded-full";

  const css_class = `${
    options.class || "h-7 w-7"
  } ${rounded} overflow-hidden shrink-0`;

  let styles = "";

  if (css_class.indexOf("border-white") >= 0) {
    styles += "border-color: white;";
  }

  if (user.avatar) {
    // Avoid infinite loops in onerror with this.onerror = null
    return `<img loading="lazy" title="${scrubHtml(user.name)}" src="${user.avatar}" class="${css_class}" style="${styles}" onerror="this.onerror=null; this.src='https://i2.wp.com/a.slack-edge.com/df10d/img/avatars/ava_0006-72.png'" />`;
  }

  return initialsAvatar(user, css_class);
}
